import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, vModelText as _vModelText, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "tw-flex tw-h-[3px] tw-mt-4 tw-w-full tw-bg-[#b4b4b4]" }, null, -1)
const _hoisted_3 = { class: "tw-px-[5em] tw-mt-4 tw-mb-[50px]" }
const _hoisted_4 = { class: "tw-bg-white tw-rounded-xl tw-p-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-text-center tw-text-lg tw-text-[20px] tw-border-b-[2px] tw-border-[#b0b0b0] tw-pb-2" }, " FOREIGN ", -1)
const _hoisted_6 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-pb-4 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_7 = { class: "tw-px-4" }
const _hoisted_8 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5 tw-text-left" }
const _hoisted_9 = { class: "tw-w-full" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "SELECT TYPE", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT OPTION", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Residential", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Investment", -1)
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "tw-w-full"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "SELECT INVESTMENT TYPE", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT OPTION", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "passive" }, "Passive", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "shortterm" }, "Short term", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", { value: "flips" }, "Flips", -1)
const _hoisted_21 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 0,
  class: "d-flex tw-justify-center gap-5 mt-4 mb-4"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex tw-items-end gap-3" }, [
  /*#__PURE__*/_createTextVNode("CASH"),
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-money-bill-alt tw-text-[#00a0da] tw-text-[35px]" })
], -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex tw-items-end gap-3" }, [
  /*#__PURE__*/_createTextVNode("FINANCING"),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hand-holding-usd tw-text-[#00a0da] tw-text-[35px]" })
], -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "d-flex tw-justify-center gap-5 mt-4 mb-4"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex tw-items-end gap-3" }, [
  /*#__PURE__*/_createTextVNode("AS IS"),
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-money-bill-alt tw-text-[#00a0da] tw-text-[35px]" })
], -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex tw-items-end gap-3" }, [
  /*#__PURE__*/_createTextVNode("PROPERTY READY"),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hand-holding-usd tw-text-[#00a0da] tw-text-[35px]" })
], -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 0,
  class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-pb-4 tw-rounded-xl tw-overflow-hidden tw-relative"
}
const _hoisted_33 = {
  class: "modal fade",
  id: "exampleModalMessage",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_34 = { class: "modal-dialog" }
const _hoisted_35 = { class: "content-mensage modal-content tw-bg-[#E6E7E8]" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "boton-mensage modal-header tw-flex tw-items-center tw-outline-none tw-bg-[#00a0da] tw-border-[#00a0da] tw-bordered-[20px]" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title tw-text-white tw-text-xl",
    id: "exampleModalLabel"
  }, "New Message"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle tw-text-[25px] tw-text-white" })
  ])
], -1)
const _hoisted_37 = { class: "modal-body" }
const _hoisted_38 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "USER-EMAIL: ", -1)
const _hoisted_40 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "SUBJECT: ", -1)
const _hoisted_42 = { class: "tw-mt-5 tw-w-full tw-flex tw-justify-center tw-items-center" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "tw-pl-5" }, null, -1)
const _hoisted_44 = { class: "modal-footer tw-flex tw-items-center tw-justify-between" }
const _hoisted_45 = { class: "tw-flex tw-justify-start tw-items-center" }
const _hoisted_46 = {
  key: 0,
  class: "btn-attach tw-bg-[#E6E7E8] tw-h-[40px] tw-font-bold tw-px-4 tw-rounded-full tw-text-xl"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip tw-text-gray-500" }, null, -1)
const _hoisted_48 = { class: "tw-flex tw-justify-end tw-items-center" }
const _hoisted_49 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_ResidentialView = _resolveComponent("ResidentialView")!
  const _component_TotalCashMonthly = _resolveComponent("TotalCashMonthly")!
  const _component_TotalFinancingMonthlyPayment = _resolveComponent("TotalFinancingMonthlyPayment")!
  const _component_PasiveCash = _resolveComponent("PasiveCash")!
  const _component_PasiveFinancial = _resolveComponent("PasiveFinancial")!
  const _component_ShortTermCash = _resolveComponent("ShortTermCash")!
  const _component_ShortTermFinancing = _resolveComponent("ShortTermFinancing")!
  const _component_FlipAsIs = _resolveComponent("FlipAsIs")!
  const _component_FlipPropertyReady = _resolveComponent("FlipPropertyReady")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["tw-fixed tw-top-0 tw-left-0", { 'tw-w-full tw-h-full': _ctx.loaderConfig.isLoading }])
    }, [
      _createVNode(_component_loading, {
        active: _ctx.loaderConfig.isLoading,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loaderConfig.isLoading) = $event)),
        "can-cancel": false,
        loader: 'dots',
        "is-full-page": !_ctx.loaderConfig.fullPage
      }, null, 8, ["active", "is-full-page"])
    ], 2),
    _createVNode(_component_TopBar, {
      helpBar: true,
      helpDescription: "Video tutorial",
      helpVideo: "https://www.realtortools.org/media/Foreign.MP4"
    }),
    _createElementVNode("div", null, [
      _createVNode(_component_ResidentialView, { header: false })
    ]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("select", {
                  name: "",
                  id: "typeforeign",
                  class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.foreign.selectType) = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.foreign.selectTypeName = null))
                }, _hoisted_14, 544), [
                  [_vModelSelect, _ctx.foreign.selectType]
                ])
              ]),
              (_ctx.foreign.selectType == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("select", {
                      name: "",
                      id: "",
                      class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectInvestmentType($event)))
                    }, _hoisted_21, 32)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.foreign.selectType == 0 || _ctx.foreign.selectType == 1 && _ctx.foreign.selectTypeName && (_ctx.foreign.selectTypeName.includes('investment-passive') || _ctx.foreign.selectTypeName.includes('investment-shortterm')))
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", {
                    class: "d-flex tw-items-center",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectForeignType('cash')))
                  }, _hoisted_24),
                  _createElementVNode("div", {
                    class: "d-flex tw-items-center",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectForeignType('financed')))
                  }, _hoisted_26)
                ]))
              : _createCommentVNode("", true),
            (_ctx.foreign.selectType == 1 && _ctx.foreign.selectTypeName && _ctx.foreign.selectTypeName.includes('flips'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("div", {
                    class: "",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectForeignType('asis')))
                  }, _hoisted_29),
                  _createElementVNode("div", {
                    class: "",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectForeignType('propertyready')))
                  }, _hoisted_31)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.foreign.selectType != null && _ctx.foreign.selectTypeName && (_ctx.foreign.selectTypeName.includes('cash') || _ctx.foreign.selectTypeName.includes('financed') || _ctx.foreign.selectTypeName.includes('asis') || _ctx.foreign.selectTypeName.includes('propertyready')))
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              (_ctx.foreign.selectTypeName == 'residential-cash')
                ? (_openBlock(), _createBlock(_component_TotalCashMonthly, {
                    key: 0,
                    header: false,
                    foreign: " "
                  }))
                : _createCommentVNode("", true),
              (_ctx.foreign.selectTypeName == 'residential-financed')
                ? (_openBlock(), _createBlock(_component_TotalFinancingMonthlyPayment, {
                    key: 1,
                    header: false,
                    foreign: " "
                  }))
                : _createCommentVNode("", true),
              (_ctx.foreign.selectTypeName == 'investment-passive-cash')
                ? (_openBlock(), _createBlock(_component_PasiveCash, {
                    key: 2,
                    header: false,
                    foreign: "pasive_cash"
                  }))
                : _createCommentVNode("", true),
              (_ctx.foreign.selectTypeName == 'investment-passive-financed')
                ? (_openBlock(), _createBlock(_component_PasiveFinancial, {
                    key: 3,
                    header: false,
                    foreign: "pasive_financial"
                  }))
                : _createCommentVNode("", true),
              (_ctx.foreign.selectTypeName == 'investment-shortterm-cash')
                ? (_openBlock(), _createBlock(_component_ShortTermCash, {
                    key: 4,
                    header: false,
                    foreign: "short_term_cash"
                  }))
                : _createCommentVNode("", true),
              (_ctx.foreign.selectTypeName == 'investment-shortterm-financed')
                ? (_openBlock(), _createBlock(_component_ShortTermFinancing, {
                    key: 5,
                    header: false,
                    foreign: "short_term_financial"
                  }))
                : _createCommentVNode("", true),
              (_ctx.foreign.selectTypeName == 'investment-flips-asis')
                ? (_openBlock(), _createBlock(_component_FlipAsIs, {
                    key: 6,
                    header: false,
                    foreign: "flip_as_is"
                  }))
                : _createCommentVNode("", true),
              (_ctx.foreign.selectTypeName == 'investment-flips-propertyready')
                ? (_openBlock(), _createBlock(_component_FlipPropertyReady, {
                    key: 7,
                    header: false,
                    foreign: "flip_property_ready"
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.scenarioMail.email) = $event)),
                class: "tw-w-full tw-h-[32px]",
                style: {"padding-left":"10px"}
              }, null, 512), [
                [_vModelText, _ctx.scenarioMail.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.scenarioMail.subject) = $event)),
                class: "tw-w-full tw-h-[32px]",
                style: {"padding-left":"10px"}
              }, null, 512), [
                [_vModelText, _ctx.scenarioMail.subject]
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _withDirectives(_createElementVNode("textarea", {
                name: "",
                id: "",
                cols: "53",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.scenarioMail.message) = $event)),
                rows: "9"
              }, null, 512), [
                [_vModelText, _ctx.scenarioMail.message]
              ])
            ])
          ]),
          _hoisted_43,
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              (_ctx.scenarioMail.file)
                ? (_openBlock(), _createElementBlock("button", _hoisted_46, [
                    _hoisted_47,
                    _createTextVNode(" " + _toDisplayString(_ctx.scenarioMail.file.name), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("button", {
                "data-bs-dismiss": "modal",
                class: "tw-bg-[#78c18a] disabled:tw-bg-[#cfcfcf] disabled:tw-text-white tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl",
                disabled: _ctx.v$.scenarioMail.$invalid,
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.sendScenarioMail && _ctx.sendScenarioMail(...args)))
              }, "SEND MESSAGE", 8, _hoisted_49)
            ])
          ])
        ])
      ])
    ])
  ]))
}